import { object, string } from "yup";

export default ({
  intl,
  isSportEvent,
  showSportDataConfig,
  isLocalRecEvent = false,
  apiForm = false,
  scoreboardTypeRequired = true,
}) => {
  const requiredText = intl.formatMessage({ id: "app.form.required" });
  const getMaxLengthMsg = ({ max }) => intl.formatMessage({ id: "app.form.maxLength" }, { max });

  const mandatoryData = showSportDataConfig
    ? {
        teamName1Abreviated: string()
          .nullable()
          .max(4, getMaxLengthMsg)
          .required(requiredText),
        teamName2Abreviated: string()
          .nullable()
          .max(4, getMaxLengthMsg)
          .required(requiredText),
      }
    : {
        teamName1Abreviated: string()
          .max(4, getMaxLengthMsg)
          .nullable(),
        teamName2Abreviated: string()
          .max(4, getMaxLengthMsg)
          .nullable(),
      };

  const scoreboardTypeSchema =
    !isLocalRecEvent && scoreboardTypeRequired ? string().required(requiredText) : string().nullable();

  return isSportEvent
    ? apiForm ? {
          sportEventData: object()
              .shape({
                  ...mandatoryData,
                  scoreboardTemplateId: string().nullable(),
                  scoreboardType: scoreboardTypeSchema,
                  teamName1: string().nullable(),
                  teamLogo1: string().nullable(),
                  teamName2: string().nullable(),
                  teamLogo2: string().nullable(),
              })
              .required(requiredText),
      } : {
        sportEventData: object()
          .shape({
            ...mandatoryData,
            scoreboardTemplateId: string().nullable(),
            scoreboardType: scoreboardTypeSchema,
            teamName1: string().nullable(),
            teamLogo1: string().nullable(),
            teamLogoAsset1: object().shape({
              codename: string(),
              image: string(),
              description: string(),
            }),
            teamName2: string().nullable(),
            teamLogo2: string().nullable(),
            teamLogoAsset2: object().shape({
              codename: string(),
              image: string(),
              description: string(),
            }),
          })
          .required(requiredText),
      }
    : {};
};
